import { type FC, useMemo } from 'react';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';

import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentCargoTypes } from '../../hooks';

interface CargoTypeSelectProps
  extends Pick<FormItemProps, 'rules' | 'name'>,
    Pick<SelectProps, 'placeholder' | 'disabled'> {
  label?: string;
  editMode?: boolean;
  value?: unknown;
  tooltip?: string;
  margin?: string;
  mode?: 'multiple' | 'tags';
  isDefault?: boolean;
  onChange?: (value?: unknown) => void;
  disableDefaultOptions?: boolean;
  singleLineMode?: boolean;
}

export const CargoTypeSelect: FC<CargoTypeSelectProps> = ({
  placeholder = i18n.t('translation:default.fields.cargoType.placeholder'),
  label = i18n.t('translation:default.fields.cargoType.label'),
  rules = [],
  name,
  editMode,
  value,
  tooltip,
  margin = 'mb-0',
  mode,
  isDefault = false,
  onChange,
  disableDefaultOptions = false,
  singleLineMode = false,
  disabled,
}) => {
  const { data = [], isLoading } = useGetShipmentCargoTypes();

  const options = useMemo(
    () =>
      data.map((row) => ({
        label: row.codeDesc?.trim(),
        value: row.codeId?.trim(),
      })),
    [data],
  );

  return (
    <FormSelectBox
      loading={isLoading}
      options={
        !disableDefaultOptions
          ? isDefault
            ? [{ label: 'Select', value: '' }, ...options]
            : [{ label: 'All', value: '*' }, ...options]
          : options
      }
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      value={value}
      tooltip={tooltip}
      mode={mode}
      onChange={onChange}
      singleLineMode={singleLineMode}
      disabled={disabled}
    />
  );
};
